import React from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useMediaQuery } from "react-responsive";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { routePaths } from "../../../config/route-paths";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  floatLeft: {
    float: "left",
  },
  primaryColor: {
    color: theme.palette.ePrimary.base + " !important",
    backgroundColor: "none",
  },
  marginRight: {
    marginRight: "-10px",
  },
  primaryColorSF: {
    color: theme.palette.ePrimary.base + " !important",
    backgroundColor: "none",
    marginBottom: "5px",
  },
}));

const Backlink = (props) => {
  const classes = useStyles();
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.SEARCH);
  const { t: labelsBack, ready: labelready } = useTranslation("label-USER_MANAGEMENT");
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 768px)" });
  const history = useHistory();
  const backCall = () => {
    if (props.backToHome) {
      history.push(routePaths.LOGIN);
    } else {
      // history.length >= 1 ? history.goBack() : history.push(routePaths.LOGIN);
       history.push(routePaths.LOGIN);
    }
  };
  return (
    <div>
      {isTabletOrMobile ? (
        <div className={classes.floatLeft}>
          <Button
            className={classes.primaryColor}
            size="small"
            startIcon={
              <ArrowBackIosIcon
                fontSize="small"
                className={classes.marginRight}
              />
            }
            onClick={backCall}
          >
            <b>{labelsBack("QUICKPAY_BACK_BUTTON")}</b>
          </Button>
        </div>
      ) : (
        <Button
          className={classes.primaryColorSF}
          size="small"
          startIcon={<ArrowBackIosIcon fontSize="small" />}
          onClick={backCall}
        >
          <b>{labels?.SEARCH_BACK}</b>
        </Button>
      )}
    </div>
  );
};

export default Backlink;
